/**
 * URL base de la API — único lugar donde se resuelve el backend.
 *
 * Prioridad:
 *   1. window.__ENV__.BACKEND_URL  → config inyectada en runtime (opcional)
 *   2. REACT_APP_BACKEND_URL       → solo desarrollo (yarn start contra :8001)
 *   3. ''                          → producción: ruta relativa /api (nginx hace proxy)
 *
 * Gracias al fallback relativo, UNA sola imagen del frontend sirve para todos
 * los clientes: no hay que recompilar por cada VPS. La URL del backend ya no
 * se hornea en build-time.
 */
const BACKEND_URL =
  (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__.BACKEND_URL) ||
  process.env.REACT_APP_BACKEND_URL ||
  '';

export const API = `${BACKEND_URL}/api`;
